// Storage utility to handle persistence
const storage = {
  // Initialize session
  initSession: () => {
    if (!sessionStorage.getItem('formSessionActive')) {
      sessionStorage.setItem('formSessionActive', 'true');
      sessionStorage.setItem('sessionStartTime', new Date().toISOString());
    }
  },

  // Check if session is active
  isSessionActive: () => {
    return sessionStorage.getItem('formSessionActive') === 'true';
  },

  // Get item from storage
  getItem: (key) => {
    try {
      // Initialize session if not active
      if (!storage.isSessionActive()) {
        storage.initSession();
      }
      return localStorage.getItem(key);
    } catch (error) {
      console.error('Error getting item from storage:', error);
      return null;
    }
  },

  // Set item in storage
  setItem: (key, value) => {
    try {
      storage.initSession();
      localStorage.setItem(key, value);
    } catch (error) {
      console.error('Error setting item in storage:', error);
    }
  },

  // Remove item from storage
  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('Error removing item from storage:', error);
    }
  },

  // Clear all form data and end session
  endSession: () => {
    try {
      sessionStorage.removeItem('formSessionActive');
      sessionStorage.removeItem('sessionStartTime');
      const keys = Object.keys(localStorage);
      keys.forEach(key => {
        if (key.includes('step') || 
            key.includes('selected') || 
            key.includes('pipedrive')) {
          localStorage.removeItem(key);
        }
      });
    } catch (error) {
      console.error('Error clearing storage:', error);
    }
  },

  // Clear all data and restart from step 1
  restartOnboarding: () => {
    // Save token before clearing
    const step1Data = JSON.parse(localStorage.getItem('step1Data') || '{}');
    const customToken = step1Data.customToken;

    storage.endSession();
    storage.initSession();

    // Restore token if it existed
    if (customToken) {
      storage.setItem('step1Data', JSON.stringify({ customToken }));
    }
  },

  // Store Pipedrive data (person and deal IDs)
  setPipedriveData: (personId, dealId, organizationId = null) => {
    const pipedriveData = {
      personId,
      dealId,
      ...(organizationId && { organizationId })
    };
    storage.setItem('pipedriveData', JSON.stringify(pipedriveData));
  },

  // Get Pipedrive data
  getPipedriveData: () => {
    const data = storage.getItem('pipedriveData');
    return data ? JSON.parse(data) : null;
  },

  // Initialize session listener
  initSessionListener: () => {
    // Only clear data when tab/browser closes, not on refresh
    window.addEventListener('unload', () => {
      if (!window.performance.navigation.type === 1) { // Not a refresh
        storage.endSession();
      }
    });

    // Clear data after 30 minutes of inactivity
    const checkActivity = () => {
      const sessionStart = sessionStorage.getItem('sessionStartTime');
      if (sessionStart) {
        const inactiveTime = new Date() - new Date(sessionStart);
        if (inactiveTime > 30 * 60 * 1000) { // 30 minutes
          storage.endSession();
        }
      }
    };

    // Check activity every minute
    setInterval(checkActivity, 60 * 1000);
  }
};

export default storage; 